const adminSelectors = {
  loading: state => state.adminReducer.loading,
  admin: state => state.adminReducer.admin,
};

export default adminSelectors;